<template>
  <div class="mainContainer">
    <first-section
      v-if="businessPage !== null"
      :title="businessPage.section_1_title"
      :description="businessPage.section_1_description"
      :picture_url="businessPage.section_1_picture_url"
      :button_title="businessPage.section_1_button_title"
      :button_url="businessPage.section_1_button_url"
    />
    <second-section
      v-if="businessPage !== null"
      :title_1="businessPage.section_2_title"
      :description_1="businessPage.section_2_description"
      :picture_url_1="businessPage.section_2_picture_url"
      :button_title_1="businessPage.section_2_button_title"
      :button_url_1="businessPage.section_2_button_url"
      :title_2="businessPage.section_3_title"
      :description_2="businessPage.section_3_description"
      :picture_url_2="businessPage.section_3_picture_url"
      :button_title_2="businessPage.section_3_button_title"
      :button_url_2="businessPage.section_3_button_url"
    />
    <fifth-section
      v-if="businessPage !== null"
      :title="businessPage.section_4_title"
      :description="businessPage.section_4_description"
      :button_title="businessPage.section_4_button_title"
      :button_url="businessPage.section_4_button_url"
    />
    <Footer />
  </div>
</template>

<style scoped>
@import "../../assets/css/bla_style.css";
</style>

<script>
import axios from 'axios';
import Footer from '@/views/public/partials/Footer';
import FirstSection from './FirstSection.vue';
import SecondSection from './SecondSection.vue';
import FifthSection from './FifthSection.vue';

export default {
  components: {
    Footer,
    FirstSection,
    SecondSection,
    FifthSection,
  },
  data: () => ({
    businessPage: null,
  }),
  methods: {
    checkAndLoadBusinessPage() {
      axios
        .post(this.$store.getters.getApiUrl + '/api/business-page/load', {
          url: this.$route.params.url,
        })
        .then((response) => {
          if (response.data.load) {
            // console.log("business-page data: ", response.data);
            this.businessPage = response.data.businessPage;
          } else {
            //Redirect to 404
            this.$router.push({ name: 'Home' });
          }
        })
        .catch((error) => {
          if (error.length > 0) {
            console.log('question- error: ', error);
          }
        });
    },
  },
  mounted: function () {
    this.checkAndLoadBusinessPage();
  },
};
</script>
